'use strict';

var semver = require('semver');

var _require = require('../constants/signiantCommunicationServiceVersions'),
    PROXY_REQUEST_COMMAND_VERSION = _require.PROXY_REQUEST_COMMAND_VERSION,
    UPLOAD_ALL_TRANSFER_LOGS_VERSION = _require.UPLOAD_ALL_TRANSFER_LOGS_VERSION;

var _require2 = require('../constants/jetVersions'),
    MOVE_AFTER_TRANSFER_VERSION = _require2.MOVE_AFTER_TRANSFER_VERSION,
    DELETE_AFTER_TRANSFER_VERSION = _require2.DELETE_AFTER_TRANSFER_VERSION,
    FILE_BASED_TRANSFERS_VERSION = _require2.FILE_BASED_TRANSFERS_VERSION,
    AWS_S3_TRANSFERS_VERSION = _require2.AWS_S3_TRANSFERS_VERSION,
    GCS_TRANSFERS_VERSION = _require2.GCS_TRANSFERS_VERSION,
    DISCOVER_WALK_MODE_FOLDER_MONITORS_VERSION = _require2.DISCOVER_WALK_MODE_FOLDER_MONITORS_VERSION,
    FLIGHT_GATEWAY_FOR_S3_TRANSFERS_VERSION = _require2.FLIGHT_GATEWAY_FOR_S3_TRANSFERS_VERSION,
    RELAY_SUPPORT_VERSION = _require2.RELAY_SUPPORT_VERSION,
    BANDWIDTH_MANAGEMENT_VERSION = _require2.BANDWIDTH_MANAGEMENT_VERSION,
    PULL_TRANSFERS_SUPPORT_VERSION = _require2.PULL_TRANSFERS_SUPPORT_VERSION,
    MEDIA_ENGINE_INDEXING_VERSION = _require2.MEDIA_ENGINE_INDEXING_VERSION,
    WASABI_OBJECT_STORAGE_TRANSFERS_VERSION = _require2.WASABI_OBJECT_STORAGE_TRANSFERS_VERSION,
    GROWING_OBJECTS_TRANSFERS_VERSION = _require2.GROWING_OBJECTS_TRANSFERS_VERSION,
    AZURE_BLOB_STORAGE_TRANSFERS_VERSION = _require2.AZURE_BLOB_STORAGE_TRANSFERS_VERSION,
    MEDIA_ENGINE_PROXY_EXTRACTION_VERSION = _require2.MEDIA_ENGINE_PROXY_EXTRACTION_VERSION;

var _require3 = require('./deviceVersions'),
    getSigniantCommunicationServiceVersion = _require3.getSigniantCommunicationServiceVersion,
    getSdcxVersion = _require3.getSdcxVersion;

var deviceSupportsProxyRequestCommand = function deviceSupportsProxyRequestCommand(device) {
    return semver.satisfies(getSigniantCommunicationServiceVersion(device), '>=' + PROXY_REQUEST_COMMAND_VERSION);
};

var deviceSupportsUploadAllTransferLogsCommand = function deviceSupportsUploadAllTransferLogsCommand(device) {
    return semver.satisfies(getSigniantCommunicationServiceVersion(device), '>=' + UPLOAD_ALL_TRANSFER_LOGS_VERSION);
};

var deviceSupportsDeleteJetFilesCommand = function deviceSupportsDeleteJetFilesCommand(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + DELETE_AFTER_TRANSFER_VERSION);
};

var deviceSupportsMoveJetFilesCommand = function deviceSupportsMoveJetFilesCommand(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + MOVE_AFTER_TRANSFER_VERSION);
};

var deviceSupportsFileBasedTransfers = function deviceSupportsFileBasedTransfers(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + FILE_BASED_TRANSFERS_VERSION);
};

var deviceSupportsAwsS3JetTransfers = function deviceSupportsAwsS3JetTransfers(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + AWS_S3_TRANSFERS_VERSION);
};

var deviceSupportsGcsJetTransfers = function deviceSupportsGcsJetTransfers(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + GCS_TRANSFERS_VERSION);
};

var deviceSupportsDiscoverWalkModeFolderMonitors = function deviceSupportsDiscoverWalkModeFolderMonitors(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + DISCOVER_WALK_MODE_FOLDER_MONITORS_VERSION);
};

var deviceSupportsFlightGatewayForS3Transfers = function deviceSupportsFlightGatewayForS3Transfers(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + FLIGHT_GATEWAY_FOR_S3_TRANSFERS_VERSION);
};

var deviceSupportsJetRelayTransfers = function deviceSupportsJetRelayTransfers(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + RELAY_SUPPORT_VERSION);
};

var deviceSupportsPullTransfers = function deviceSupportsPullTransfers(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + PULL_TRANSFERS_SUPPORT_VERSION);
};

var deviceSupportsBandwidthManagement = function deviceSupportsBandwidthManagement(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + BANDWIDTH_MANAGEMENT_VERSION);
};

var deviceSupportsMediaEngineIndexing = function deviceSupportsMediaEngineIndexing(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + MEDIA_ENGINE_INDEXING_VERSION);
};

var deviceSupportsWasabiObjectStorageJetTransfers = function deviceSupportsWasabiObjectStorageJetTransfers(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + WASABI_OBJECT_STORAGE_TRANSFERS_VERSION);
};

var deviceSupportsGrowingObjectsTransfers = function deviceSupportsGrowingObjectsTransfers(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + GROWING_OBJECTS_TRANSFERS_VERSION);
};

var deviceSupportsAzureStorageJetTransfers = function deviceSupportsAzureStorageJetTransfers(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + AZURE_BLOB_STORAGE_TRANSFERS_VERSION);
};

var deviceSupportsMediaEngineProxyExtraction = function deviceSupportsMediaEngineProxyExtraction(device) {
    return semver.satisfies(getSdcxVersion(device), '>=' + MEDIA_ENGINE_PROXY_EXTRACTION_VERSION);
};

module.exports = {
    deviceSupportsProxyRequestCommand: deviceSupportsProxyRequestCommand,
    deviceSupportsUploadAllTransferLogsCommand: deviceSupportsUploadAllTransferLogsCommand,
    deviceSupportsDeleteJetFilesCommand: deviceSupportsDeleteJetFilesCommand,
    deviceSupportsMoveJetFilesCommand: deviceSupportsMoveJetFilesCommand,
    deviceSupportsFileBasedTransfers: deviceSupportsFileBasedTransfers,
    deviceSupportsAwsS3JetTransfers: deviceSupportsAwsS3JetTransfers,
    deviceSupportsGcsJetTransfers: deviceSupportsGcsJetTransfers,
    deviceSupportsDiscoverWalkModeFolderMonitors: deviceSupportsDiscoverWalkModeFolderMonitors,
    deviceSupportsFlightGatewayForS3Transfers: deviceSupportsFlightGatewayForS3Transfers,
    deviceSupportsJetRelayTransfers: deviceSupportsJetRelayTransfers,
    deviceSupportsBandwidthManagement: deviceSupportsBandwidthManagement,
    deviceSupportsPullTransfers: deviceSupportsPullTransfers,
    deviceSupportsMediaEngineIndexing: deviceSupportsMediaEngineIndexing,
    deviceSupportsWasabiObjectStorageJetTransfers: deviceSupportsWasabiObjectStorageJetTransfers,
    deviceSupportsGrowingObjectsTransfers: deviceSupportsGrowingObjectsTransfers,
    deviceSupportsAzureStorageJetTransfers: deviceSupportsAzureStorageJetTransfers,
    deviceSupportsMediaEngineProxyExtraction: deviceSupportsMediaEngineProxyExtraction
};